import { combine, withCallbacks } from 'react-hooks-combine'
import { withFormModel } from 'shared/hooks'
import { spec, validators } from 'utils/validation'

import AddMemberBankAccountFormComponent from './component'

const { any, string } = validators

export const AddMemberBankAccountForm = combine(
  withFormModel(
    () => {
      return {
        displayName: {
          initialValue: '',
          spec: spec.flow(string.isNotEmpty, any.required),
        },
        accountNumber: {
          initialValue: '',
          spec: spec.flow(string.isNotEmpty, any.required),
        },

        bankName: {
          initialValue: '',
          spec: spec.flow(string.isNotEmpty, any.required),
        },

        currency: {
          initialValue: '',
          spec: spec.flow(string.isNotEmpty, any.required),
        },

        iban: {
          initialValue: '',
          spec: spec.flow(string.isNotEmpty, any.required),
        },
      }
    },
    { id: 'member-add-bank-account-form' }
  ),

  withCallbacks(
    {
      onSubmitRequest: {
        deps: ['onSubmit'],
        func:
          (_state, { onSubmit }) =>
          (form) => {
            return onSubmit(form)
          },
      },
    },
    []
  )
)(AddMemberBankAccountFormComponent)
